<template>
  <div>
    <Input @on-focus="open" readonly v-model="text"></Input>
    <Modal width="700" class="my-drawer" title="城市选择器" v-model="opendrawer" footer-hide>
      <Tag color="red">常用城市</Tag>
      <ul class="changyongcity">
        <li @click="clickChangyong(item)" v-for="(item, index) in changyong" :key="index">
          {{ item.name }}
        </li>
      </ul>

      <Tag color="red">其他城市</Tag>
      <Button size="small" type="primary" @click="ok">选好了</Button>
      <div class="citywrap" ref="wrap">
        <Input placeholder="请选择" :readonly="isread" v-model="text" @on-clear="clear" @on-focus="focus"
          @on-change="change" ref="city" clearable>
        <Button @click="search" slot="append" icon="md-search"></Button>
        </Input>
        <div ref="citydiv" class="citylist" :class="{ bottom: bottom }">
          <ul v-show="x.length > 0 && isread" v-for="(x, index1) in cityList" :key="index1">
            <li :class="{ active: item.select }" @click="next(item, index1, true)" v-for="(item, index2) in x"
              :key="index2">
              <span>{{ item.name }}</span>
            </li>
          </ul>
          <ul v-show="!isread">
            <li @click="searchclick(item)" v-for="(item, index) in searchList" :key="index">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
      
    </Modal>
  </div>
</template>
<script>
export default {
  props: ["cctyy"],
  model: {
    prop: "cctyy",
    event: "aaa",
  },
  data() {
    return {
      opendrawer: false,
      result: "",
      changyong: [
        {
          name: "深圳",
          lng: "",
          lat: "",
        },
        {
          name: "广州",
          lng: "",
          lat: "",
        },
        {
          name: "香港",
          lng: "",
          lat: "",
        },
        {
          name: "东莞",
          lng: "",
          lat: "",
        },
        {
          name: "惠州",
          lng: "",
          lat: "",
        },
      ],
      text: "", 
      showText: '',
      adcode: '',
      show: false,
      cityList: [[], [], [], [], []],
      value: [],
      isread: true,
      searchList: [], //sousuo列表
      all: [], //所有数据
      linshitext: "", //临时文本
      bottom: false,
      last: true,

      proCityArea: []//省市区
    };
  },
  methods: {
    open() {
      this.opendrawer = true;
      this.chushihua();
    },
    ok() {
      this.opendrawer = false;
      this.$emit("aaa", this.text);
      this.$emit("adcode", this.adcode);
      this.$emit("addAdcode", this.text+'-'+this.adcode);

    },
    clickChangyong(v) {
      this.text = v.name;
      this.adcode = v.adcode;
      this.showText = v.name;
      //常用地址，寻找上级
      let result = [];
      this.findParent(this.all, this.text, result, []);
      this.proCityArea = result;
      this.ok();
    },
    getList() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-web/area/list",
        data: {},
      }).then((res) => {
        this.changyong = [];
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          var obj = {
            name: data[i].name,
            adcode: data[i].adcode,
          };
          this.changyong.push(obj);
        }
        this.tableData = data;
      });
    },
    //
    fuzhi() {
      this.show = false;
      if (this.text.length == 0) {
        this.text = this.linshitext;
      }
    },
    focus() {
      this.show = true;
    },
    //点击下级城市
    next(v, index, ishand) {

      for (let j = 0; j < this.cityList[index].length; j++) {
        this.cityList[index][j].select = false;
      }
      v.select = true;

      if (v.districtList) {
        var gol = this.cityList[index + 1];
        this.cityList[index + 1].length = 0;
        this.cityList[index + 2].length = 0;
        this.cityList[index + 3].length = 0;
        for (let i = 0; i < v.districtList.length; i++) {
          //v.districtList[i].select = false;
          this.$set(v.districtList[i], "select", false);
          gol.push(v.districtList[i]);
        }
      } else {
        if (ishand) {
          // this.show = false;
        }
      }
      this.getValue(v);
    },
    //获取结果
    getValue(v) {

      if (this.last) {
        this.text = v.name;
        this.showText=v.name;
        this.adcode = v.adcode;
      } else {
        var city = this.cityList;
        var arr = this.proCityArea;
        var mmm = this.adcode;
        arr.length = 0; mmm.length = 0;
        for (let i = 0; i < city.length; i++) {
          for (let j = 0; j < city[i].length; j++) {
            if (city[i][j].select) {
              arr.push(city[i][j].name);
              mmm.push(city[i][j].adcode);
            }
          }
        }
        this.text = arr.join("/");
      }

      //this.$emit("aaa", this.text);
    },
    //初始化
    chushihua() {
      this.all = [];
      var city = this.city;
      this.isread = true;
      this.cityList = [[], [], [], [], []];
      for (let i = 0; i < city.length; i++) {
        // this.city[i].select = false;
        //if (city[i].name == "香港" || city[i].name == "广东") {
          this.$set(this.city[i], "select", false);
          this.all.push(city[i]);
          this.cityList[0] = this.all;
        //}
      }
      this.getList();
      //chushihua
    },
    cityToArr() {
      //this.value = this.cctyy.split("/");
      //this.chushihua();

      this.text = this.cctyy;
      //this.showText = this.cctyy.split('-')[0];
      //console.log(this.showText);
    },
    clear() {
      this.value = [];
      this.cityList = [];
      this.getValue();
    },
    //点开搜索按钮
    search() {
      this.linshitext = this.text;
      this.text = "";
      this.isread = false;
      setTimeout(() => {
        this.$refs.city.focus();
      }, 200);
    },
    //搜索结果点击
    searchclick(v) {
      this.value = v.split("/");
      if (this.last) {
        this.text = this.value[this.value.length - 1];
      } else {
        this.text = v;
      }
      this.show = false;
      this.isread = true;
    },
    change(v) {
      if (!this.isread) {
        let result = [];
        this.findParent(this.all, this.text, result, []);
        this.searchList = [result.join("/")];
      }
    },

    //data：要遍历的数据， target：查找目标， result用于装查找结果的数组
    findParent(data, target, result) {
      for (let i = 0; i < data.length; i++) {
        let item = data[i];

        if (item.name.indexOf(target) != -1) {
          //将查找到的目标数据加入结果数组中
          //可根据需求unshift(item.id)或unshift(item)
          result.unshift(item.name);
          return true;
        }
        if (item.districtList && item.districtList.length > 0) {
          let ok = this.findParent(item.districtList, target, result);
          if (ok) {
            result.unshift(item.name);
            return true;
          }
        }
      }
      //走到这说明没找到目标
      return false;
    },
    findAdcode() {

    }
  },
  mounted() {
    this.cityToArr();
  },
  watch: {
    cctyy() {
      this.cityToArr();
    },
  },
};
</script>
<style>
.changyongcity {
  display: flex;
  margin-top: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.changyongcity li {
  padding: 4px 10px;
  cursor: pointer;
}

.citywrap {
  position: relative;
}

.citylist {
  height: 350px;
  background: #fff;
  display: flex;
  border: solid 1px #ccc;
  padding: 2px 0;
}

.bottom {
  top: auto !important;
  bottom: 36px;
}

.citylist ul {
  height: 100%;
  overflow: auto;
  min-width: 150px;
  line-height: 1;
}

.citylist ul li {
  cursor: pointer;
  display: flex;
  padding: 6px 10px;
}

.citylist ul li.active {
  color: red;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/common/selectCity.vue